export default __webpack_public_path__ + "static/media/voyce-logo.ce0a080a.png";